import { useEffect, useState, useCallback, useRef } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
//import { GinecologiaRecord } from './GinecologiaRecord';
import Webcam from "react-webcam";
import moment from "moment";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './FT.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';


let emp = 0;

const modeloDatos = {
    pacienteID: 0,
    empresaid: emp
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , tipoOrden: 0
    , seguroID: 0
    , nombreSeguro: ''
    , poliza: ''
    , centroID: 0
    , diagnostico: ''
    , diagnosticoClinico: ''
    , direccion: ''
    , tratamientoID: 0
    , nombreTratamiento: ''
    , resultado: ''
    , toxicos: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''
    , alergicos: ''
    , antecedentesMedicos: ''
    , antecedentesMedicamentos: ''
    , examenFisico: ''
    , antecedentesFamiliares: ''
    , habitosAlimenticios: ''
    , tipoSangre: 'A+'
    , tiempoCasada: 0
    , embarazada: 0
    , fechaInicioEmbarazo: new Date
    , edadMenarquia: 0
    , cicloM: 'Regular'
    , duracionCiclo: 0,
    dolor: 'No',
    noGestas: 0,
    noAbortos: 0,
    noCesareas: 0,
    noPartos: 0,
    metodoAnticonceptivo: '',

    motivoConsultaP: '',
    referidoPor: '',
    nombreEsposo: '',
    otraEnfermedades: '',
    enfermedadesInfancia: '',
    tabaco: 0,
cafe:0,
alcohol:0


}
const modeloRecord = {
    recordPacienteGastroID: 0,
    empresaID: emp,
    pacienteID: 0,
    historiaClinica: '',
    comentario: '',
    fecha: new Date,
    codigoUnico: '',
    embarazada: 0,
    semanaEmbarazo: 0.00,
    presionAlterial: '',
    peso: '',
    centimetros: '',
    frecuenciaBebe: ''
}
const modeloReceta = {
    recetaID: 0,
    empresaID: emp,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: '',
    dosificacion: '',
    CodigoUnicoRecord: ''
}
let options = [];
let optionsP = [];
let optionsT = [{ descripcion: "" }];

const Ginecologia = () => {
    emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;

    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaT, setTablaT] = useState([]);
    const [tablaRecord, setTablaRecord] = useState(modeloRecord);
    const [tablaReceta, setTablaReceta] = useState(modeloReceta);
    const [Listado, SetListado] = useState([]);
    const [ListadoSeg, SetListadoSeg] = useState([]);
    const [ListadoTox, SetListadoTox] = useState([]);
    const [ListadoRecord, SetListadoRecord] = useState([]);
    const [ListadoReceta, SetListadoReceta] = useState([]);
    const [ListadoMedicamento, SetListaMedicamento] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [Camara, SetCamara] = useState(false);
    const [Receta, SetReceta] = useState(false);
    const [Embarazada, SetEmbarazada] = useState(false);
    const [VerEmbarazada, SetVerEmbarazada] = useState(false);
    const [imageSrc, setImageSrc] = useState("");

    const [Inicio, SetInicio] = useState(false);


    //toast.configure();

   

    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;

        var searchData = l.filter((item) => {
            if (
                (item.nombres + item.apellidos + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())

            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    const handleChangeT = (e) => {

        setTabla({
            ...tabla,
            ["toxicos"]: tabla.toxicos + ", " + e.target.value
        });

    }

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        if (e.target.name == "sexo") {
            icono(e.target.value)
        }
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(e.target.value);
        }
        else {
            setTabla({
                ...tabla,
                [e.target.name]: e.target.value
            })
        }
    }
    const handleChangeRecord = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaRecord({
            ...tablaRecord,
            [e.target.name]: e.target.value
        })
    }
    const handleChangeReceta = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaReceta({
            ...tablaReceta,
            [e.target.name]: e.target.value
        })
    }

    const handleChange2 = (e) => {
        setTablaReceta({
            ...tablaReceta,
            ["medicamentoID"]: e.value, ["nombreMedicamento"]: e.nombre, ["pacienteiD"]: paciente.pacienteID, ["recordPacienteID"]: tablaRecord.recordPacienteGastroID
        })
    }


    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);
        setTabla({
            ...tabla, nombres: "", apellidos: "", cedula: x
        })
        if (nomb.length != 0) {
            var e = nomb[0].nombres + " EXISTE"
            MensajeG(e)
            setVerModal(!verModal);
            Setpaciente(nomb[0])
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    icono((data1[0]).sexo);
                    setTabla({
                        ...tabla, nombres: (data1[0]).nombres, apellidos: (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x,
                        fechaNacimiento: (data1[0]).fechaNacimiento, sexo: (data1[0]).sexo
                    })
                } else {
                    setTabla({
                        ...tabla, nombres: "", apellidos: "", cedula: x
                    })
                }
            }
        }
    }

    const MensajeG = (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });
    const fetchImage = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + emp);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Ginecologo/ListaGinecologo/" + correo + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListado1(data);
            setPendiente(false)

            if (Inicio == false) {
                SetListado(data);
                SetInicio(true);
            }



        }
    }

    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + correo + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }

    const ObtenerRecord = async (e) => {
        let response = await fetch(Api + "Ginecologo/ListaRecordPacienteGinecologo/" + e + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoRecord(data)
        }
    }
    const ObtenerReceta = async (d) => {
        let response = await fetch(Api + "Ginecologo/RecetasGinecologo/" + d + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoReceta(data)
        }
    }
    const ObtenerMedicamento = async () => {
        let response = await fetch(Api + "Ginecologo/MedicamentosGinecologo");
        if (response.ok) {
            let data = await response.json()
            SetListaMedicamento(data)
            data.map(x => {
                options.push({
                    value: x.medicamentoID, label: x.descripcion, nombre: x.descripcion
                })
            })
        }
    }
    const ObtenerPruebas = async () => {
        let response = await fetch(Api + "Ginecologo/ListaPruebas");
        if (response.ok) {
            let data = await response.json()
              data.map(x => {
                optionsP.push({
                    value: x.pruebaID, label: x.descripcion, nombre: x.descripcion
                })
            })
        }
    }


    useEffect(() => {
        obtenerDatos();
        obtenerDatosSeg();
        fetchImage();
    }, [])

    useEffect(() => {
        ObtenerMedicamento();
        obtenerDatosToxico();
        ObtenerPruebas()
    }, [])


    const abrirRecord = (data) => {
        Setpaciente(data);
        ObtenerRecord(data.pacienteID);
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        var editando = 0;
        tabla.embarazada = parseInt(tabla.embarazada)
        tabla.tiempoCasada = tabla.tiempoCasada + ''
        if (tabla.pacienteID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Ginecologo/GuardarPacientesGinecologo", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Ginecologo/EditarPacientesGinecologo", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

            editando = 1;
        }

        if (response.ok) {
            SetInicio(false);
            obtenerDatos();

            let data1 = await response.json()
            ObtenerRecord(data1.pacienteID)
            if (editando == 0) {
                Setpaciente(data1)
            }
            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }

            MensajeG("Guardado")

        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosRecord = async () => {
        let response;
        if (tablaRecord.recordPacienteGastroID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            response = await fetch(Api + "Ginecologo/GuardarRecordPacienteGinecologo", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })

        } else {
            response = await fetch(Api + "Ginecologo/EditarRecordPacienteGinecologo", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
            tablaRecord.recordPacienteGastroID = data1.recordPacienteGastroID
            tablaRecord.codigoUnico = data1.codigoUnico

            await ObtenerRecord();
            MensajeG("Guardado")
            // setTablaRecord(modeloRecord);
            SetReceta(true);

        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosReceta = async () => {
        let response;
        if (tablaReceta.recetaID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            response = await fetch(Api + "Ginecologo/GuardarRecetaGinecologo", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        } else {
            response = await fetch(Api + "Ginecologo/EditarRecetaGinecologo", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        }

        if (response.ok) {

            await ObtenerReceta(tablaRecord.recordPacienteGastroID);

            SetReceta(modeloReceta);
            MensajeG()
            // Setpaciente([]);

        } else {
            alert("error al guardar")
        }

    }
    const EliminarReceta = async (id) => {
        const response = fetch(Api + "Ginecologo/EliminarRecetaGinecologo/" + id, { method: "DELETE" })
            .then(response => {
                if (response.ok) {
                    ObtenerReceta(tablaRecord.recordPacienteGastroID)
                }
            })
    }
    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            SetInicio(false)
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }
    const cerrarModalR = () => {
        setTablaRecord(modeloRecord)
        SetVerEmbarazada(false)
    }

    const columns = [

        {
            name: 'Pacientes ',
            selector: row => row.nombres + " " + row.apellidos,
            sortable: true,
            width: window.innerWidth < 844 ? '30%' : '20%',
        },
        {
            name: 'Celular ',
            selector: row => row.celular,
            sortable: true,
            omit: window.innerWidth <= 845,
            width: '10%'

        }, {
            name: 'Seguro ',
            selector: row => (row.nombreSeguro),
            sortable: true,
            omit: window.innerWidth < 844,
            width: '15%'
        },

        {
            name: 'IMPORTANTE RECORDAR ',
            selector: row => (row.diagnosticoClinico),
            sortable: true,
            style: {
                color: "red"

            },
               omit: window.innerWidth < 844,
            width: '20%'
        },



        {
            name: '',

            cell: row => (
                <>
                    <Button class="btn" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirRecord(row)} hidden={row.embarazada}
                    >
                        <i className="fas fa-user-tag"></i>
                    </Button>

                    <Button color="primary" size="sm" className="mr-2" hidden={!row.embarazada }
                        onClick={() => TratarEmbarazada(row)}
                    >
                        <i className="fas fa-user-tag"></i>
                    </Button>

                </>
            ), width: window.innerWidth < 844 ? '15%' : '20',
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    const videoConstraints = {
        width: 20,
        height: 20,
        facingMode: "user"
    };
    const webcamRef = useRef(null);
    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            SetCamara(false)

            tabla.imagen = imageSrc;
            document.getElementsByName("imagen").value = imageSrc;
        },
        [webcamRef]

    );
    const Atras = () => {
        Setpaciente([])
        SetEmbarazada(false)
    }
    const TerminarReceta = (d) => {
        if (d != '0') {
            window.open("/ImpresionReceta/" + d + "/ImpresionRecetaGinecologia.html" + "/Ginecologo", '_blank');
        }

        obtenerDatos()
        Setpaciente([])
        setTablaReceta(modeloReceta)
        setTablaRecord(modeloRecord)
        SetReceta(false)

    }
    const icono = (d) => {
        const profileIcon = document.getElementById('profileIcon');
        if (d === 'F') {
            profileIcon.innerHTML = '👩';
        } else if (d === 'M') {
            profileIcon.innerHTML = '👨';
        } else {
            profileIcon.innerHTML = '👤';
        }
    };


    const obtenerDatosToxico = async () => {
        let response = await fetch(Api + "CMantenimiento/listaToxicos");
        if (response.ok) {
            let data = await response.json()
            SetListadoTox(data)

        }
    }

    function calcularEdad(fechaNacimiento, fechaActual) {
        var nacimiento = new Date(fechaNacimiento);
        var actual = new Date(fechaActual);

        var edad = actual.getFullYear() - nacimiento.getFullYear();
        var mes = actual.getMonth() - nacimiento.getMonth();
        var dia = actual.getDate() - nacimiento.getDate();

        // Ajustar si el mes o el día no ha pasado aún este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad--;
        }

        return edad;
    }

    const TratarEmbarazada = (d) => {
        SetEmbarazada(true)
        // Calcular la diferencia en milisegundos
        var fechaInicio = new Date( moment(d.fechaInicioEmbarazo).format("YYYY-MM-DD"));
        var fechaFin = new Date( moment( new Date()).format("YYYY-MM-DD"));

        var diff = fechaFin - fechaInicio;
        Setpaciente(d);
        ObtenerRecord(d.pacienteID);
        tablaRecord.semanaEmbarazo = calcularSemanas(fechaInicio, fechaFin);
     
    }
    function calcularSemanas(fechaInicio, fechaFin) {
        const unDia = 1000 * 60 * 60 * 24; // Milisegundos en un día
        const diferenciaDias = (fechaFin - fechaInicio) / unDia;
        return Math.floor(diferenciaDias / 7);
    }

   
    const VerRecord = (x) => {
        ObtenerReceta(x.recordPacienteGastroID)
        setTablaRecord(x);
        SetVerEmbarazada(true)
            
    }

    return (
        <>
            {/* //<img src={imageSrc} alt="Imagen cargada" width="200" className="rounded shadow-sm" />*/ }

            <ToastContainer />
            <div hidden={paciente.length == 0 && tabla.embarazada == 0} >


                <div class="containerR">

                    <div class="">

                        <h1>Consulta Médica</h1>
                    </div>
                    <div class="patient-info">
                        <div class="info-item">
                            <span class="info-label">Nombres y Apellidos:</span>
                            {paciente.nombres + " " + paciente.apellidos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Edad:</span>

                            {calcularEdad(paciente.fechaNacimiento, new Date())}
                        </div>
                  
                        <div class="info-item">
                            <span class="info-label">ARS / Afiliado:</span>
                            {paciente.nombreSeguro} / {paciente.poliza}
                        </div>

                        <div class="info-item">
                            <span class="info-label">Gestas:</span>
                         <b> Embarazos:</b>  {paciente.noGestas}
                         <b> Partos:</b>  {paciente.noPartos}
                            <b> Abortos:</b>   {paciente.noAbortos}
                            <b> Cesareas:</b>  {paciente.noCesareas}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Ciclos Menstrual:</span>
                            <b> Ciclo:</b>  {paciente.cicloM}
                            <b> Duracion:</b>  {paciente.duracionCiclo}
                            <b> Dolor:</b>   {paciente.dolor}
                          
                        </div>

                        <div class="info-item">
                            <span class="info-label">Tóxicos:</span>
                            {paciente.toxicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Alergicos:</span>
                            {paciente.alergicos}
                        </div>
                                  <div class="info-item">
                            <span class="info-label">Anticonceptivo:</span>
                            {paciente.metodoAnticonceptivo}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Antecedentes Ginecologico:</span>
                            {paciente.antecedentesFamiliares}
                        </div>
            
                        <div class="info-item" style={{ color: "red" }}>
                            <span class="info-label" style={{ color: "red" }}>MUY IMPORTANTE RECORDAR:</span>
                            {paciente.diagnosticoClinico}
                        </div>
                    </div>

                

                    <div class="">
                        <div class="row">
                         
                            <div class="col-md-6">
                                <h4 class="mb-4"><b>Consulta</b></h4>

                                <form>
                                    {Embarazada && (    <div class="row mb-3">
                                        <div class="col-md-2">
                                            <label for="semanaEmbarazo" class="form-label">Semanas</label>
                                            <input type="text" class="form-control" id="semanaEmbarazo" name="semanaEmbarazo"
                                                value={tablaRecord.semanaEmbarazo} disabled />
                                        </div>
                                        <div class="col-md-2">
                                            <label for="peso" class="form-label">Peso</label>
                                            <input type="text" class="form-control" id="peso" name="peso"
                                                value={tablaRecord.peso} onChange={handleChangeRecord} />
                                        </div>
                                   
                                     <div class="col-md-2">
                                            <label for="centimetros" class="form-label">Centímetros</label>
                                            <input type="text" class="form-control" id="centimetros" name="centimetros"
                                                value={tablaRecord.centimetros} onChange={handleChangeRecord} />
                                        </div>
                                        <div class="col-md-3">
                                            <label for="presionAlterial" class="form-label">Presión Arterial</label>
                                            <input type="text" class="form-control" id="presionAlterial" name="presionAlterial"
                                                value={tablaRecord.presionAlterial} onChange={handleChangeRecord} />
                                        </div>
                                      
                                        <div class="col-md-3">
                                            <label for="frecuenciaBebe" class="form-label">Frecu. del Bebé</label>
                                            <input type="text" class="form-control" id="frecuenciaBebe" name="frecuenciaBebe"
                                                value={tablaRecord.frecuenciaBebe} onChange={handleChangeRecord} />
                                        </div>
                                    </div>
                                    )}

                                    <div class="mb-3">
                                        <label for="historiaClinica" class="form-label">Historia Clínica</label>
                                        <textarea class="form-control" id="historiaClinica" name="historiaClinica" rows="3"
                                            onChange={handleChangeRecord} value={tablaRecord.historiaClinica}></textarea>
                                    </div>

                                    <div class="mb-3">
                                        <label for="comentario" class="form-label">Comentario</label>
                                        <textarea class="form-control" id="comentario" name="comentario" rows="3"
                                            onChange={handleChangeRecord} value={tablaRecord.comentario}></textarea>
                                    </div>

                                    <div class="d-flex justify-content-end">
                                        <button type="button" class="btn btn-danger me-2" onClick={Atras}>Cerrar</button>
                                        <button type="button" class="btn btn-primary" onClick={guardarCambiosRecord}
                                            disabled={!tablaRecord.historiaClinica}>Siguiente</button>
                                    </div>
                                </form>
                            </div>

                        
                            <div class="col-md-6">
                                <h4 class="mb-4"><b>Historial de consulta</b></h4>

                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Descripción</th>
                                            <th>Comentario</th>
                                            <th>Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ListadoRecord.map(x => (
                                            <tr key={x.codigoUnico}>
                                                <td>{moment(x.fecha).format("DD/MM/YY")}
                                                    <Button onClick={()=>VerRecord(x) } ><i className="fa fa-eye"></i></Button>
                                                </td>
                                                <td>
                                                    <textarea class="form-control" rows="2" value={x.historiaClinica} disabled></textarea>
                                                </td>
                                                <td>
                                                    <textarea class="form-control" rows="2" value={x.comentario} disabled></textarea>
                                                </td>
                                                <td>
                                                    <a class="btn btn-outline-secondary" target="_blank"
                                                        href={`/ImpresionReceta/${x.codigoUnico}/ImpresionRecetaGinecologia.html/Ginecologo`}>
                                                        🖨️
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>






            <Col md="12" hidden={paciente.length != 0}>
                <Card>
                    <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                        <Row>
                            <Col md="7" >
                                <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de paciente " ></Input></Col>

                            <Col md="4" >

                                <Button color="success" size="md"
                                    onClick={() => setVerModal(!verModal)}
                                ><b>Nuevo Paciente</b></Button>
                                <Button color="warning" size="md"
                                //    href="/ReportesGinecologo"
                                ><b>Reporte</b></Button>
                            </Col></Row>
                    </CardHeader>
                    <CardBody>

                        <DataTable
                            columns={columns}
                            data={Listado}
                            progressPending={pendiente}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}


                        />
                    </CardBody>
                </Card>
            </Col>


           

            <Modal className="modal-preguntas" isOpen={verModal}>

                <ModalBody>

                    {/*FORMULARIO*/}
                
                    <div class="containerp">
                        <div class="form-header">
                            <div class="box">
                                <div>Mantenimiento de Pacientes </div>
                                <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                            </div>

                            <div id="profileIcon" class="profile-icon">👤</div>
                        </div>
                        <form class="form-content">
                            <h5>DATOS PERSONALES</h5>
                          
                            <div class="form-row">

                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="cedula">Cédula</label>
                                        <input type="text" id="cedula" name="cedula" onChange={handleChange} value={tabla.cedula} maxlength="11" required />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="nombres">Nombres</label>
                                        <input type="text" id="nombres" name="nombres" value={tabla.nombres}
                                            placeholder="Nombres" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="apellidos">Apellidos</label>
                                        <input type="text" id="apellidos" name="apellidos" value={tabla.apellidos}
                                            placeholder="Apellidos" onChange={handleChange} required />
                                    </div>
                                </div>
                           
                                {/*<div class="form-col">*/}
                                {/*    <div class="form-group">*/}
                                {/*        <label for="telefono">Teléfono</label>*/}
                                {/*        <input type="tel" id="telefono" name="telefono" mask="999-999-9999"*/}
                                {/*            value={tabla.telefono} onChange={handleChange} />*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                               <div class="form-col">
                                    <div class="form-group">
                                        <label for="fechaNacimiento">Fecha de Nacimiento</label>
                                        <input type="date" id="fechaNacimiento" name="fechaNacimiento" value={Moment(tabla.fechaNacimiento).format('YYYY-MM-DD')}
                                            placeholder="FechaNacimiento" onChange={handleChange} />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="celular">Celular</label>
                                        <input type="tel" id="celular" name="celular" mask="999-999-9999" onChange={handleChange} value={tabla.celular} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="seguro">Seguro</label>
                                        <select id="seguroID" name="seguroID"
                                            value={tabla.seguroID} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            {ListadoSeg.map(x =>
                                                <option value={x.seguroID}> {x.descripcion}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="afiliado">No. Afiliado</label>
                                        <input type="text" id="poliza" name="poliza" value={tabla.poliza}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="celular">Esposo</label>
                                        <input type="tel" id="celular" name="nombreEsposo"  onChange={handleChange} value={tabla.nombreEsposo} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="celular">ReferidoPor</label>
                                        <input type="tel" id="celular" name="referidoPor" onChange={handleChange} value={tabla.referidoPor} />
                                    </div>
                                </div>
                            </div>
                            <label for="antecedentes-familiares">Motivo de la Consulta</label>
                            <textarea id="antecedentes-familiares" name="motivoConsultaP" value={tabla.motivoConsultaP}
                                onChange={handleChange} rows="2" cols="30"></textarea>

                            <br></br>
                            <h5>ANTECEDENTES FAMILIARES</h5>
                            <label for="antecedentes-familiares">Antecedentes familiares :</label>
                            <textarea id="antecedentes-familiares" name="antecedentesFamiliares" value={tabla.antecedentesFamiliares}
                                onChange={handleChange} rows="2" cols="30"></textarea>
                            <br></br>
                            <h5>ANTECEDENTES PERSONALES</h5>
                            <div class="form-row">

                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Enfermedades Infancia</label>
                                        <input type="text" id="toxicos" name="enfermedadesInfancia" value={tabla.enfermedadesInfancia} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Otras</label>
                                        <input type="text" id="toxicos" name="otraEnfermedades" value={tabla.otraEnfermedades} onChange={handleChange}></input>
                                    </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="diagnostico">Alergias</label>
                                        <input type="text" id="toxicos" name="alergicos" value={tabla.alergicos} onChange={handleChange}></input>
                                        </div>
                                        </div>
                                        <div class="form-col">
                                            <div class="form-group">
                                                <label for="diagnostico">Tabaco</label>
                                        <select id="alcohol" name="tabaco" value={tabla.tabaco} title="()" onChange={handleChange}>
                                            <option value="1">Sí</option>
                                            <option value="0">No</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Cafe</label>
                                        <select id="alcohol" name="cafe" value={tabla.cafe} title="()" onChange={handleChange}>
                                            <option value="1">Sí</option>
                                            <option value="0">No</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Alcohol</label>
                                             <select id="alcohol" name="alcohol" value={tabla.alcohol} title="()" onChange={handleChange}>
                                            <option value="1">Sí</option>
                                            <option value="0">No</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Otros</label>
                                        <input type="text" id="toxicos" name="toxicos" value={tabla.toxicos} onChange={handleChange}></input>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <h5>ANTECEDENTES GINECOLOGICOS</h5>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="menarquia">Edad de menarquia :</label>
                                        <input type="number" id="menarquia" name="edadMenarquia" value={tabla.edadMenarquia} min="8" max="18"
                                            title="(primer período menstrual)" required onChange={handleChange} />
                                    </div>
                                </div>

                               


                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="ciclo">Ciclo menstrual:</label>
                                            <select id="ciclo" name="cicloM" required value={tabla.cicloM} onChange={handleChange}>
                                                <option value="Regular">Regular</option>
                                                <option value="Irregular">Irregular</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="duracion">Duración del ciclo (en días):</label>
                                            <input type="number" id="duracion" name="duracionCiclo" min="21" max="35" value={tabla.duracionCiclo} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div class="form-col">
                                        <div class="form-group">
                                            <label for="dismenorrea">¿Presenta dismenorrea?</label>
                                            <select id="dismenorrea" name="dolor" value={tabla.dolor} title="(dolor menstrual)" onChange={handleChange}>
                                                <option value="Si">Sí</option>
                                                <option value="No">No</option>
                                            </select>
                                        </div>
                                    </div>
                                <div class="form-col" >
                                    <div class="form-group">
                                        <label for="resultado">Fecha Ultimo Periodo</label>
                                        <input type="date" name="fechaInicioEmbarazo" value={Moment(tabla.fechaInicioEmbarazo).format("YYYY-MM-DD")}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                </div>


                            <h5>ANTECEDENTES OBSTRETICOS</h5>
                            <div class="form-row">
                                <div class="form-col" >
                                    <div class="form-group">
                                        <label for="sexo">Tipo Sangre</label>
                                        <select id="tipoSangre" name="tipoSangre" value={tabla.tipoSangre} onChange={handleChange}>
                                            <option value="A+">A+</option>
                                            <option value="A-">A-</option>
                                            <option value="B+">B+</option>
                                            <option value="B-">B-</option>
                                            <option value="AB+">AB+</option>
                                            <option value="AB-">AB-</option>
                                            <option value="O+">O+</option>
                                            <option value="O-">O-</option>
                                        </select>
                                       
                                        <select hidden id="sexo" name="sexo" value={tabla.sexo} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            <option value="F">Femenino</option>
                                            <option value="M">Masculino</option>
                                        </select>
                                    </div>
                                </div>
                             
                          
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="gestas">Número de embarazos:</label>
                                        <input type="number" id="gestas" name="noGestas" min="0" value={tabla.noGestas} onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="partos">Número de partos:</label>
                                        <input type="number" id="partos" name="noPartos" min="0" value={tabla.noPartos} onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="abortos">Número de abortos:</label>
                                        <input type="number" id="abortos" name="noAbortos" min="0" value={tabla.noAbortos} onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="cesareas">Número de cesáreas:</label>
                                        <input type="number" id="cesareas" name="noCesareas" min="0" value={tabla.noCesareas} onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="cesareas">Otro tipo de Embarazo:</label>
                                        <textarea type="textArea" id="nombreTratamiento" name="nombreTratamiento" value={tabla.nombreTratamiento} onChange={handleChange} />
                                    </div>
                                </div>
                               
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="metodo-anticonceptivo">Método anticonceptivo actual:</label>
                                        <select id="metodo-anticonceptivo" name="metodoAnticonceptivo" value={tabla.metodoAnticonceptivo} onChange={handleChange}>
                                            <option value="Ninguno">Ninguno</option>
                                            <option value="Pildora">Píldora anticonceptiva</option>
                                            <option value="Dispositivo">DIU</option>
                                            <option value="Inyectable">Inyectable</option>
                                            <option value="Parche">Parche anticonceptivo</option>
                                            <option value="Implante">Implante subdérmico</option>
                                            <option value="Condon">Condón</option>
                                            <option value="Otro">Otro</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Tiempo con tu pareja</label>
                                        <input type="text" id="tiempoCasada" name="tiempoCasada" value={tabla.tiempoCasada}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Embarazada</label>
                                        <select value={tabla.embarazada} onChange={handleChange} name="embarazada"  >
                                            <option value="0">No</option>
                                            <option value="1">Si</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col" hidden={!tabla.embarazada}>
                                    <div class="form-group">
                                        <label for="resultado">Fecha Ultimo Periodo</label>
                                        <input type="date" name="fechaInicioEmbarazo" value={Moment(tabla.fechaInicioEmbarazo).format("YYYY-MM-DD")}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                </div>

                            {/*ANTECEDENTES GINECOLOGICOS*/}
                           

                                                      
                         


                            <div class="form-row">
                        
                             
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Diagnóstico</label>
                                        <input type="text" id="diagnostico" name="diagnostico" value={tabla.diagnostico} id="diagnostico"
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnosticoClinico" style={{ color: "red" }} >DIAGNOSTICO CLINICO IMPORTANTE PARA RECORDAR</label>
                                        <input type="text" id="diagnosticoClinico" name="diagnosticoClinico" value={tabla.diagnosticoClinico}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                              

                            </div>
                            <div class="form-row" hidden>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Alergicos</label>
                                        <input type="text" id="alergicos" name="alergicos" value={tabla.alergicos}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Medicos</label>
                                        <input type="text" id="antecedentesMedicos" name="antecedentesMedicos" value={tabla.antecedentesMedicos}
                                            onChange={handleChange} />
                                    </div>
                                </div>         <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Medicamentos</label>
                                        <input type="text" id="antecedentesMedicamentos" name="antecedentesMedicamentos" value={tabla.antecedentesMedicamentos}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>
                            <div class="form-row">
                               

                            </div>

                                                    

                            <div class="btn-group">
                                <button type="button" onClick={cerrarModal} class="btn btn-danger">Cerrar</button>
                                <button type="button" class="btn btn-primary" onClick={guardarCambios}>Guardar</button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
                <ModalFooter>

                </ModalFooter>
            </Modal>

            <Modal isOpen={Camara}>
                <ModalHeader>
                    TOMAR FOTO
                </ModalHeader>
                <ModalBody>
                    <div >
                        <Webcam
                            audio={false}
                            height={400}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={400}
                            videoConstraints={videoConstraints}
                        />
                        <button onClick={capture}>Tomar Foto</button>

                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => SetCamara(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal isOpen={Receta} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Receta a Nombre de: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => TerminarReceta(0)}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <Tabs >
                        <TabList>
                            <Tab>RECETA</Tab>
                            <Tab>ESTUDIO/EXAMEN</Tab>
                        </TabList>

                        <TabPanel>

                            <div >
                                <Row>
                                    <Col md="3">  <FormGroup>

                                        <Label>* Medicamento</Label>
                                        <Select
                                            name={"medicamentoID"}
                                            onChange={handleChange2}
                                            value={options.filter(x => x.value == tablaReceta.medicamentoID).map(x => x)}
                                            options={options}
                                        /></FormGroup></Col>


                                    <Col md="2">  <FormGroup > <Label for="exampleEmail">Dosificacion</Label>
                                        <Input type="text" name="dosificacion" value={tablaReceta.dosificacion} id="comentario"
                                            placeholder="dosificacion" onChange={handleChangeReceta} />

                                    </FormGroup>  </Col>
                                    <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                        <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                            placeholder="Comentario" onChange={handleChangeReceta} />

                                    </FormGroup>  </Col>
                                    <Col md="2">
                                        <Button size="sm" color="primary"
                                            onClick={guardarCambiosReceta}
                                        >Agregar</Button></Col>

                                </Row>
                                <table>
                                    <tr>
                                        <th>Medicamento</th>
                                        <th>Dosificacion</th>
                                        <th>Comentario</th>
                                        <th>Quitar</th>
                                    </tr>
                                    {ListadoReceta.map(x => (
                                        <tr>
                                            <td>{x.nombreMedicamento}</td>
                                            <td>{x.dosificacion}</td>
                                            <td>{x.comentario}</td>
                                            <td> <Button size="sm" color="danger"
                                                onClick={() => EliminarReceta(x.codigoUnico)}
                                            >X</Button></td>
                                        </tr>
                                    ))}
                                </table>

                            </div>


                        </TabPanel>
                        <TabPanel>
                            <div >
                                <Row>
                                    <Col md="3">  <FormGroup>

                                        <Label>* Estudio</Label>
                                        <Select
                                            name={"PruebaID"}
                                            onChange={handleChange2}
                                            value={options.filter(x => x.value == tablaReceta.medicamentoID).map(x => x)}
                                            options={optionsP}
                                        /></FormGroup></Col>


                                    <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                        <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                            placeholder="Comentario" onChange={handleChangeReceta} />

                                    </FormGroup>  </Col>
                                    <Col md="2">
                                        <Button size="sm" color="primary"
                                            onClick={guardarCambiosReceta}
                                        >Agregar</Button></Col>

                                </Row>
                                <table>
                                    <tr>
                                        <th>Examen / Estudio</th>
                                        <th>Categoria</th>
                                        <th>Comentario</th>
                                        <th>Quitar</th>
                                    </tr>
                                    {ListadoReceta.map(x => (
                                        <tr>
                                            <td>{x.nombreMedicamento}</td>
                                            <td>{x.dosificacion}</td>
                                            <td>{x.comentario}</td>
                                            <td> <Button size="sm" color="danger"
                                                onClick={() => EliminarReceta(x.codigoUnico)}
                                            >X</Button></td>
                                        </tr>
                                    ))}
                                </table>

                            </div>
                        </TabPanel>
                    </Tabs>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" size="sx" target="_blank"
                        onClick={() => TerminarReceta(tablaRecord.codigoUnico)}
                    ><i className="fa fa-print"></i></Button>
                    <Button size="sm" color="danger"
                        onClick={() => TerminarReceta(0)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Embarazada*/}

            <Modal isOpen={VerEmbarazada}  className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Embarazada: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModalR()}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <div>
                        <Row>
                        <div class="col-md-6">
                            <h4 class="mb-4"><b>Consulta</b></h4>

                            <form>
                                {Embarazada && (<div class="row mb-3">
                                    <div class="col-md-2">
                                        <label for="semanaEmbarazo" class="form-label">Semanas</label>
                                        <input type="text" class="form-control" id="semanaEmbarazo" name="semanaEmbarazo"
                                            value={tablaRecord.semanaEmbarazo} disabled />
                                    </div>
                                    <div class="col-md-2">
                                        <label for="peso" class="form-label">Peso</label>
                                        <input type="text" class="form-control" id="peso" name="peso"
                                            value={tablaRecord.peso} />
                                    </div>

                                    <div class="col-md-2">
                                        <label for="centimetros" class="form-label">Centímetros</label>
                                        <input type="text" class="form-control" id="centimetros" name="centimetros"
                                            value={tablaRecord.centimetros}  />
                                    </div>
                                    <div class="col-md-3">
                                        <label for="presionAlterial" class="form-label">Presión Arterial</label>
                                        <input type="text" class="form-control" id="presionAlterial" name="presionAlterial"
                                            value={tablaRecord.presionAlterial} />
                                    </div>

                                    <div class="col-md-3">
                                        <label for="frecuenciaBebe" class="form-label">Frecu. del Bebé</label>
                                        <input type="text" class="form-control" id="frecuenciaBebe" name="frecuenciaBebe"
                                            value={tablaRecord.frecuenciaBebe}  />
                                    </div>
                                </div>
                                )}

                                <div class="mb-3">
                                    <label for="historiaClinica" class="form-label">Historia Clínica</label>
                                    <textarea class="form-control" id="historiaClinica" name="historiaClinica" rows="3"
                                        value={tablaRecord.historiaClinica}></textarea>
                                </div>

                                <div class="mb-3">
                                    <label for="comentario" class="form-label">Comentario</label>
                                    <textarea class="form-control" id="comentario" name="comentario" rows="3"
                                       value={tablaRecord.comentario}></textarea>
                                </div>

                              
                            </form>
                        </div>

                        {/*Segunda Seccion*/}
                            <div class="col-md-6" >
                                <h4 class="mb-4"><b>Medicamento Receta</b></h4>      
                            <table>
                                <tr>
                                    <th>Medicamento</th>
                                    <th>Dosificacion</th>
                                    <th>Comentario</th>
                                </tr>
                                {ListadoReceta.map(x => (
                                    <tr>
                                        <td>{x.nombreMedicamento}</td>
                                        <td>{x.dosificacion}</td>
                                        <td>{x.comentario}</td>
                                     
                                    </tr>
                                ))}
                            </table>
                            </div>
                            </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                                    
                    <Button size="sm" color="danger"
                        onClick={() => cerrarModalR()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        </>
    )

}
export default Ginecologia;